import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children }) {
  console.log('ProtectedRoute rendering...');
  const { user, loading } = useAuth();
  const location = useLocation();

  console.log('ProtectedRoute state:', {
    user,
    loading,
    pathname: location.pathname,
    search: location.search
  });

  // Show loading state
  if (loading) {
    console.log('ProtectedRoute: showing loading state');
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    console.log('ProtectedRoute: redirecting to login');
    // Preserve the intended destination
    const loginUrl = `/login?returnUrl=${encodeURIComponent(location.pathname + location.search)}`;
    console.log('Redirecting to:', loginUrl);
    return <Navigate to={loginUrl} replace />;
  }

  console.log('ProtectedRoute: rendering protected content');
  return children;
} 